// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vx_a bhj_b bhj_wb"};